export default __webpack_public_path__ + "locales/si/ResetApplicationDialog.json?hash=f731aee37c8f3ea4554c6045a65a91d0";